import type { Member } from '@/data/types';

type T = (key: string) => string;

/**
 * The name the portal shows for an office member (Team screen, sheets, "recorded by", the timeline).
 *
 * An account deleted from the app (0086 delete_my_account) is anonymized in place: its membership stays
 * (inactive, so its name stays on past records) but the profile row is gone and auth.users.email is
 * null, so `agency_team` answers neither a name nor an email. That member reads "Deleted user", never a
 * blank cell. Everyone else: the display name, else the email.
 */
export function memberName(m: Pick<Member, 'displayName' | 'email' | 'deleted'>, t: T): string {
  if (m.deleted) return t('members.deletedUser');
  return m.displayName ?? m.email;
}
